var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-advert"},[_c('error',{attrs:{"errors":_vm.advertsError}}),_c('adverts-form',{attrs:{"action":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }